const { registerBlockType } = wp.blocks;

import attributes from './attributes';
import Edit from './edit';
import Save from './save';

registerBlockType('app/item-solution-section', {
  title: 'Sessão Solução - Card',
  description: 'Card da seção com cards em Slider',
  icon: 'slides',
  category: 'design',
  attributes,
  edit: (props) => <Edit {...props} />,
  save: (props) => <Save {...props} />,
});
